@if (component?.elements?.length) {
<div class="wrap">
    <!-- SQUARES IN ROW VARIANT -->
    @if (component.variant === 'squares_row') {
    <div>
        <div [grid]="2"
             [gridColumnGap]="4">
            @for (item of component.elements; track item) {
            <page-component-range-squares-image [item]="item"
                                                [componentVariant]="component.variant">
            </page-component-range-squares-image>
            }
        </div>
    </div>
    }
    <!-- LARGE SQUARE VARIANT -->
    @if (component.variant === 'large_square') {
    <div [grid]="1">
        <page-component-range-squares-image [item]="component.elements[0]"
                                            [componentVariant]="component.variant"></page-component-range-squares-image>
    </div>
    }
</div>
}